import { render, staticRenderFns } from "./authorizeFail.vue?vue&type=template&id=6a3f0dfc&scoped=true&"
import script from "./authorizeFail.vue?vue&type=script&lang=js&"
export * from "./authorizeFail.vue?vue&type=script&lang=js&"
import style0 from "./authorizeFail.vue?vue&type=style&index=0&id=6a3f0dfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3f0dfc",
  null
  
)

export default component.exports